(function () {
  // ajout des filtres collection :
  document.addEventListener("DOMContentLoaded", function () {
    // Vérifiez si l'élément cible existe
    const targetElement = document.querySelector(
      ".collection__filters__toggle"
    );

    if (targetElement) {
      // HTML à ajouter
      const htmlToInsert = `
            <button class="collection__numbers__toggle">
                <svg class="rk_svg-icon" viewBox="0 0 20 20">
                    <path fill="none" d="M16.803,18.615h-4.535c-1,0-1.814-0.812-1.814-1.812v-4.535c0-1.002,0.814-1.814,1.814-1.814h4.535c1.001,0,1.813,0.812,1.813,1.814v4.535C18.616,17.803,17.804,18.615,16.803,18.615zM17.71,12.268c0-0.502-0.405-0.906-0.907-0.906h-4.535c-0.501,0-0.906,0.404-0.906,0.906v4.535c0,0.502,0.405,0.906,0.906,0.906h4.535c0.502,0,0.907-0.404,0.907-0.906V12.268z M16.803,9.546h-4.535c-1,0-1.814-0.812-1.814-1.814V3.198c0-1.002,0.814-1.814,1.814-1.814h4.535c1.001,0,1.813,0.812,1.813,1.814v4.534C18.616,8.734,17.804,9.546,16.803,9.546zM17.71,3.198c0-0.501-0.405-0.907-0.907-0.907h-4.535c-0.501,0-0.906,0.406-0.906,0.907v4.534c0,0.501,0.405,0.908,0.906,0.908h4.535c0.502,0,0.907-0.406,0.907-0.908V3.198z M7.733,18.615H3.198c-1.002,0-1.814-0.812-1.814-1.812v-4.535c0-1.002,0.812-1.814,1.814-1.814h4.535c1.002,0,1.814,0.812,1.814,1.814v4.535C9.547,17.803,8.735,18.615,7.733,18.615zM8.64,12.268c0-0.502-0.406-0.906-0.907-0.906H3.198c-0.501,0-0.907,0.404-0.907,0.906v4.535c0,0.502,0.406,0.906,0.907,0.906h4.535c0.501,0,0.907-0.404,0.907-0.906V12.268z M7.733,9.546H3.198c-1.002,0-1.814-0.812-1.814-1.814V3.198c0-1.002,0.812-1.814,1.814-1.814h4.535c1.002,0,1.814,0.812,1.814,1.814v4.534C9.547,8.734,8.735,9.546,7.733,9.546z M8.64,3.198c0-0.501-0.406-0.907-0.907-0.907H3.198c-0.501,0-0.907,0.406-0.907,0.907v4.534c0,0.501,0.406,0.908,0.907,0.908h4.535c0.501,0,0.907-0.406,0.907-0.908V3.198z"></path>
                </svg>
            </button>
        `;

      // Insérer le HTML après l'élément cible
      targetElement.insertAdjacentHTML("afterend", htmlToInsert);

      // Ajouter un gestionnaire d'événement pour le clic sur le bouton
      const newButton = document.querySelector(".collection__numbers__toggle");
      newButton.addEventListener("click", function () {
        // Sélectionnez tous les éléments avec les classes à alterner
        let gridContainer = document.querySelector(".collection__products");
        gridContainer.classList.toggle("rk_grid-two");
        let gridElement = document.querySelector(".collection__products .grid");
        gridElement.classList.toggle("rk_grid");
        // const container = document.querySelector(".collection__products");

        // const elements = container.querySelectorAll(
        //   " .grid, .collection-items--mobile--one-whole, .mobile--one-whole, .collection-items--mobile--one-half, .mobile--one-half"
        // );

        // elements.forEach((element) => {
        //   if (
        //     element.classList.contains("collection-items--mobile--one-whole")
        //   ) {
        //     element.classList.remove("collection-items--mobile--one-whole");
        //     element.classList.add("collection-items--mobile--one-half");
        //     console.log(element.classList);
        //   } else if (
        //     element.classList.contains("collection-items--mobile--one-half")
        //   ) {
        //     element.classList.remove("collection-items--mobile--one-half");
        //     element.classList.add("collection-items--mobile--one-whole");
        //   }
        //   if (element.classList.contains("grid")) {
        //     element.classList.toggle("rk_grid");
        //   }
        //   if (element.classList.contains("mobile--one-whole")) {
        //     element.classList.remove("mobile--one-whole");
        //     element.classList.add("mobile--one-half");
        //   } else if (element.classList.contains("mobile--one-half")) {
        //     element.classList.remove("mobile--one-half");
        //     element.classList.add("mobile--one-whole");
        //   }
        // });
      });
    }
    // partie compte
    const adminelem = document.querySelector(".template-customers-account");

    if (adminelem) {
      const titre = adminelem.querySelector(".section__heading");

      // HTML à ajouter
      var htmlToInsert = `
            <div class="rk_icon_admin">
        <svg  viewBox="0 0 20 20">
							<path fill="none" d="M14.023,12.154c1.514-1.192,2.488-3.038,2.488-5.114c0-3.597-2.914-6.512-6.512-6.512
								c-3.597,0-6.512,2.916-6.512,6.512c0,2.076,0.975,3.922,2.489,5.114c-2.714,1.385-4.625,4.117-4.836,7.318h1.186
								c0.229-2.998,2.177-5.512,4.86-6.566c0.853,0.41,1.804,0.646,2.813,0.646c1.01,0,1.961-0.236,2.812-0.646
								c2.684,1.055,4.633,3.568,4.859,6.566h1.188C18.648,16.271,16.736,13.539,14.023,12.154z M10,12.367
								c-2.943,0-5.328-2.385-5.328-5.327c0-2.943,2.385-5.328,5.328-5.328c2.943,0,5.328,2.385,5.328,5.328
								C15.328,9.982,12.943,12.367,10,12.367z"></path>
						</svg></div>
        `;

      // Insérer le HTML après l'élément cible
      titre.insertAdjacentHTML("beforeBegin", htmlToInsert);

      const sstitre = adminelem.querySelector(
        ".account__table__item .account__heading"
      );

      // HTML à ajouter
      htmlToInsert = `
            <div class="rk_icon_admin_sub">
              <svg viewBox="0 0 20 20">
							<path d="M8.627,7.885C8.499,8.388,7.873,8.101,8.13,8.177L4.12,7.143c-0.218-0.057-0.351-0.28-0.293-0.498c0.057-0.218,0.279-0.351,0.497-0.294l4.011,1.037C8.552,7.444,8.685,7.667,8.627,7.885 M8.334,10.123L4.323,9.086C4.105,9.031,3.883,9.162,3.826,9.38C3.769,9.598,3.901,9.82,4.12,9.877l4.01,1.037c-0.262-0.062,0.373,0.192,0.497-0.294C8.685,10.401,8.552,10.18,8.334,10.123 M7.131,12.507L4.323,11.78c-0.218-0.057-0.44,0.076-0.497,0.295c-0.057,0.218,0.075,0.439,0.293,0.495l2.809,0.726c-0.265-0.062,0.37,0.193,0.495-0.293C7.48,12.784,7.35,12.562,7.131,12.507M18.159,3.677v10.701c0,0.186-0.126,0.348-0.306,0.393l-7.755,1.948c-0.07,0.016-0.134,0.016-0.204,0l-7.748-1.948c-0.179-0.045-0.306-0.207-0.306-0.393V3.677c0-0.267,0.249-0.461,0.509-0.396l7.646,1.921l7.654-1.921C17.91,3.216,18.159,3.41,18.159,3.677 M9.589,5.939L2.656,4.203v9.857l6.933,1.737V5.939z M17.344,4.203l-6.939,1.736v9.859l6.939-1.737V4.203z M16.168,6.645c-0.058-0.218-0.279-0.351-0.498-0.294l-4.011,1.037c-0.218,0.057-0.351,0.28-0.293,0.498c0.128,0.503,0.755,0.216,0.498,0.292l4.009-1.034C16.092,7.085,16.225,6.863,16.168,6.645 M16.168,9.38c-0.058-0.218-0.279-0.349-0.498-0.294l-4.011,1.036c-0.218,0.057-0.351,0.279-0.293,0.498c0.124,0.486,0.759,0.232,0.498,0.294l4.009-1.037C16.092,9.82,16.225,9.598,16.168,9.38 M14.963,12.385c-0.055-0.219-0.276-0.35-0.495-0.294l-2.809,0.726c-0.218,0.056-0.351,0.279-0.293,0.496c0.127,0.506,0.755,0.218,0.498,0.293l2.807-0.723C14.89,12.825,15.021,12.603,14.963,12.385"></path>
						</svg></div>`;

      // Insérer le HTML après l'élément cible
      sstitre.insertAdjacentHTML("beforeBegin", htmlToInsert);
    }
    const adminaddress = document.querySelector(
      ".template-customers-addresses"
    );

    if (adminaddress) {
      const address = adminaddress.querySelector(".address-title");
    
      // HTML à ajouter
      var htmlToInsert = `
            <div class="rk_icon_admin">
             <svg  viewBox="0 0 20 20">
							<path d="M10,1.375c-3.17,0-5.75,2.548-5.75,5.682c0,6.685,5.259,11.276,5.483,11.469c0.152,0.132,0.382,0.132,0.534,0c0.224-0.193,5.481-4.784,5.483-11.469C15.75,3.923,13.171,1.375,10,1.375 M10,17.653c-1.064-1.024-4.929-5.127-4.929-10.596c0-2.68,2.212-4.861,4.929-4.861s4.929,2.181,4.929,4.861C14.927,12.518,11.063,16.627,10,17.653 M10,3.839c-1.815,0-3.286,1.47-3.286,3.286s1.47,3.286,3.286,3.286s3.286-1.47,3.286-3.286S11.815,3.839,10,3.839 M10,9.589c-1.359,0-2.464-1.105-2.464-2.464S8.641,4.661,10,4.661s2.464,1.105,2.464,2.464S11.359,9.589,10,9.589"></path>
						</svg></div>`;

      // Insérer le HTML après l'élément cible
      address.insertAdjacentHTML("beforeBegin", htmlToInsert);
      const back = adminaddress.querySelector(".address-return a");
      htmlToInsert = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-select" viewBox="0 0 192 192"><path d="m72 36 60 60-60 60" stroke="#dca59a" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
      back.insertAdjacentHTML("afterbegin", htmlToInsert);
    }

    ///// augmentation qualité images
    const images = document.querySelectorAll(
      ".template-product .product-single__media img"
    );
    images.forEach((image, index) => {
      image.setAttribute(
        "sizes",
        "(min-width: 768px) calc((100vw - 40px) * 0.6 - 30px), calc(100vw - 40px)"
      );
    });
  });

  // modif des images

  const navStandardImages = document.querySelectorAll("#NavStandard img");
  navStandardImages.forEach(function (img) {
    img.setAttribute(
      "sizes",
      "(max-width: 600px) calc(((100vw * 0.6 - 30px - 60px) / 1) * 1), 600px"
    );
  });
})();
